module.exports = __webpack_public_path__ + "img/logo.c5e050dc.svg";